import { render, staticRenderFns } from "./ModalFooterSizing.vue?vue&type=template&id=188feee8"
import script from "./ModalFooterSizing.vue?vue&type=script&lang=js"
export * from "./ModalFooterSizing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports